declare const __BUILD_VERSION__: string;
declare const __BUILD_SHA__: string;
declare const __BUILD_DATE__: string;
declare const __BUILD_NUMBER__: string;

export const buildInfo = {
  version: __BUILD_VERSION__,
  sha: __BUILD_SHA__,
  date: __BUILD_DATE__,
  number: __BUILD_NUMBER__,
  environment: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
